import Repository from "../Repository";

export default {
  create: (payload) => {
    // add branch id to payload
    // payload.branch_id = JSON.parse(localStorage.getItem('currentBranch')).id;
    return Repository.post('users', payload);
  },
  update: (id, payload) => {
    return Repository.put(`admin/user/${id}`, payload);
  }
}
